import { render, staticRenderFns } from "./CurrentLessonPage.vue?vue&type=template&id=202fc950&scoped=true&"
import script from "./CurrentLessonPage.vue?vue&type=script&lang=js&"
export * from "./CurrentLessonPage.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLessonPage.vue?vue&type=style&index=0&id=202fc950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202fc950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VIcon,VMain,VProgressCircular,VSnackbar})
